module.exports = __webpack_public_path__ + "static-portal/img/map-trq.8b8b926.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/map-trq.png
// module id = EauJ
// module chunks = 4